import { useSelector } from 'react-redux';
import { AppState } from '@fullstory/redux';
import { szudzikPair } from '../utils/pairing';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { detectCardContainerType } from '../utils';

/**
 http://szudzik.com/ElegantPairing.pdf
 Pairing function for getting a unique number out of 2 numbers.
 The request sequence is (almost certainly) always small so we won't overflow.
 */
export const useCardRequestPairing = () => {
  const location = useLocation();
  const src = detectCardContainerType(location.pathname);

  /**
   * The pairing function below works with non-negative numbers, so add 1 to the request states
   */
  const lastMoveResponse =
    useSelector((state: AppState) => state.spaces.lastMovedCard.lastResponded) + 1;
  const lastUpdateResponse =
    useSelector((state: AppState) => state.spaces.lastUpdatedCard.lastResponded) + 1;
  const lastSetHomeSectionResponse =
    useSelector((state: AppState) => state.home.lastSetHomeSection.lastResponded) + 1;
  const lastSetHomeCardResponse =
    useSelector((state: AppState) => state.home.lastSetHomeCard.lastResponded) + 1;
  const lastUpdatedDashboardResponse =
    useSelector((state: AppState) => state.dashboards.lastUpdatedDashboard.lastResponded) + 1;

  const spacesPair = szudzikPair(lastMoveResponse, lastUpdateResponse);
  const homePair = szudzikPair(lastSetHomeSectionResponse, lastSetHomeCardResponse);
  const dashboardsPair = szudzikPair(lastUpdatedDashboardResponse, lastUpdateResponse);

  return useMemo(() => {
    switch (src) {
      case 'spaces':
        return spacesPair;
      case 'home':
        return homePair;
      case 'dashboards':
        return dashboardsPair;
      default:
        return 0;
    }
  }, [src, spacesPair, homePair, dashboardsPair]);
};
